export const navigation = {
  philosophy: "الفلسفة",
  services: "الخدمات",
  training: "التدريب", 
  credentials: "الشهادات",
  clientele: "العملاء",
  approach: "النهج",
  contact: "التواصل"
};

export const hero = {
  title: "الأمان الطبي النخبوي",
  subtitle: "للأفراد ذوي الثروات العالية",
  description: "تقديم خدمات التدريب والاستجابة الطبية الطارئة لا مثيل لها للعائلات فائقة الثراء والعقارات الخاصة واليخوت الفاخرة والبيئات المؤسسية الحصرية في جميع أنحاء العالم.",
  cta: "جدولة استشارة"
};

export const philosophy = {
  title: "فلسفتنا",
  subtitle: "التميز بلا تنازلات",
  description: "نحن نؤمن أن الطوارئ الطبية تتطلب تدخلاً فورياً من الخبراء. تتمحور فلسفتنا حول تقديم أعلى مستوى من التدريب الطبي وخدمات الاستجابة للطوارئ، مصممة خصيصاً للعملاء المميزين الذين لا يقبلون إلا بالأفضل."
};

export const services = {
  title: "الخدمات الأساسية",
  subtitle: "حلول طبية شاملة",
  cpr_title: "تدريب الإنعاش المتقدم",
  cpr_description: "دورات شهادة مهنية مصممة لموظفي المنازل وطاقم اليخوت وأفراد الأمن.",
  emergency_title: "الاستجابة للطوارئ",
  emergency_description: "خدمات طبية سريعة الاستجابة على مدار 24/7 مع فرق المسعفين النخبة.",
  consultation_title: "الاستشارة الطبية",
  consultation_description: "خدمات استشارية طبية متخصصة للبيئات والأنشطة عالية المخاطر."
};

export const footer = {
  copyright: "© 2024 الأطباء الأوائل. جميع الحقوق محفوظة.",
  phone: "الهاتف",
  email: "البريد الإلكتروني", 
  address: "العنوان"
};